import { Navigate, Route, Routes } from 'react-router-dom';
import { Vehicles } from './Vehicles';

export const VehiclesRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<Vehicles />} />
      <Route path="*" element={<Navigate to="." />} />
    </Routes>
  );
};
